
const HealthCreditTermsAndConditions = () => {
    return (
        <div>
            <p>Your Health Credit can be used once. It cannot be combined with other offers, has no cash value, and cannot be transferred or redeemed for cash. The Health Credit expires at 11.59pm AEST on 30 June 2026. Credits cannot be accumulated and if multiple Credits have been offered, only the latest Credit will apply. Credit is applied at Checkout if you select to apply it. The full Credit amount must be used at the one time. InstantScripts reserves the right to modify to change the offer at any time or rescind the offer for improper use. See Site T&Cs for further details.</p>
        </div>
    );
};

export default HealthCreditTermsAndConditions;    
